import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Agentation } from "agentation";

import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";

import StorefrontLayout from "./layouts/StorefrontLayout";
import AdminLayout from "./layouts/AdminLayout";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ScrollToTop from "./components/ScrollToTop";
import MyAccount from "./pages/MyAccount";
import { MentionsLegales, CGV, PolitiqueRetour } from "./pages/Legal";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminReturns from "./pages/admin/AdminReturns";
import AdminNewsletter from "./pages/admin/AdminNewsletter";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminAbandonedCarts from "./pages/admin/AdminAbandonedCarts";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminThanksEmail from "./pages/admin/AdminThanksEmail";
import AdminPromo from "./pages/admin/AdminPromo";
import AdminBanners from "./pages/admin/AdminBanners";

const Wrap = ({ children }) => <StorefrontLayout>{children}</StorefrontLayout>;

export default function App() {
  return (
    <div className="App">
      {process.env.NODE_ENV === "development" && <Agentation />}
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop/>
            <Toaster position="bottom-center" richColors closeButton/>
            <Routes>
              {/* Storefront */}
              <Route path="/" element={<Wrap><Home/></Wrap>}/>
              <Route path="/boutique" element={<Wrap><Shop/></Wrap>}/>
              <Route path="/categorie/:slug" element={<Wrap><Shop/></Wrap>}/>
              <Route path="/produit/:id" element={<Wrap><ProductDetail/></Wrap>}/>
              <Route path="/checkout" element={<Wrap><Checkout/></Wrap>}/>
              <Route path="/checkout/success" element={<Wrap><CheckoutSuccess/></Wrap>}/>
              <Route path="/connexion" element={<Wrap><Login/></Wrap>}/>
              <Route path="/inscription" element={<Wrap><Register/></Wrap>}/>
              <Route path="/verifier-email" element={<Wrap><VerifyEmail/></Wrap>}/>
              <Route path="/mot-de-passe-oublie" element={<Wrap><ForgotPassword/></Wrap>}/>
              <Route path="/reinitialiser-mot-de-passe" element={<Wrap><ResetPassword/></Wrap>}/>
              <Route path="/mon-compte" element={<Wrap><MyAccount/></Wrap>}/>
              <Route path="/mentions-legales" element={<Wrap><MentionsLegales/></Wrap>}/>
              <Route path="/cgv" element={<Wrap><CGV/></Wrap>}/>
              <Route path="/politique-retour" element={<Wrap><PolitiqueRetour/></Wrap>}/>

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin/>}/>
              <Route path="/admin" element={<AdminLayout/>}>
                <Route index element={<AdminDashboard/>}/>
                <Route path="produits" element={<AdminProducts/>}/>
                <Route path="categories" element={<AdminCategories/>}/>
                <Route path="commandes" element={<AdminOrders/>}/>
                <Route path="retours" element={<AdminReturns/>}/>
                <Route path="messages" element={<AdminMessages/>}/>
                <Route path="promo" element={<AdminPromo/>}/>
                <Route path="bannieres" element={<AdminBanners/>}/>
                <Route path="newsletter" element={<AdminNewsletter/>}/>
                <Route path="clients" element={<AdminCustomers/>}/>
                <Route path="parametres" element={<AdminSettings/>}/>
                <Route path="remerciement" element={<AdminThanksEmail/>}/>
                <Route path="paniers-abandonnes" element={<AdminAbandonedCarts/>}/>
              </Route>
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}
